import React, { createContext, useContext, useEffect, useState } from 'react';
import { fetchStockLocations } from '../utils/api';

interface StockLocation {
  id: number;
  name: string;
  address: string;
  contact_person: string;
  contact_number: string;
  created_at: string;
  updated_at: string;
}

interface StockLocationContextType {
  locations: StockLocation[];
  loading: boolean;
  error: string | null;
}

const StockLocationContext = createContext<StockLocationContextType | undefined>(undefined);

export const StockLocationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [locations, setLocations] = useState<StockLocation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadLocations = async () => {
      try {
        const data = await fetchStockLocations();

        // console.log('StockLocationProvider > data:', data);

        setLocations(data);

      } catch (err: any) {
        setError(err.message || 'Failed to fetch stock locations');
      } finally {
        setLoading(false);
      }
    };

    loadLocations();
    
  }, []);

  return (
    <StockLocationContext.Provider value={{ locations, loading, error }}>
      {children}
    </StockLocationContext.Provider>
  );
};

export const useStockLocationContext = () => {
  const context = useContext(StockLocationContext);
  if (!context) {
    throw new Error('useStockLocationContext must be used within a StockLocationProvider');
  }
  return context;
};
